import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';
import * as moment from "moment";

moment.locale('pt-BR');

interface PeriodoProducaoMultiloja {
    Id: string;
    DataTransferencia: Date;
    QuantidadeCalcinha: number;
    QuantidadeSutia: number;
    QuantidadeModelador: number;
    TotalPecas: number;
    Empresa: Empresa;
}

@Component({
    selector: 'periodo-pro-multilojas',
    templateUrl: './periodo-pro-multilojas.html'
})
export class PeriodoProducaoMultilojasComponent implements OnInit, OnDestroy {
    public hoje: string = new Date().toISOString();
    public dataInicial: string = new Date("2015-03-03").toISOString();
    public dataFinal: string = new Date().toISOString();

    @Input('analytic') analytic: boolean = false;

    public producaoMultilojaDilady: any;
    public producaoMultilojaLoveSecret: any;
    public producaoMultilojaBanhoDeMar: any;
    public producaoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this.carregandoDados = true;
        this._separarLojas();

        if (this._myInterval)
            clearInterval(this._myInterval);

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterPeriodoProducaoMultiloja().then(periodosBruto => {
            let periodos = periodosBruto.filter(a => moment(a.DataTransferencia).isBetween(this.dataInicial, this.dataFinal));

            this.producaoMultilojaGrupo = {
                QuantidadeCalcinha: _.sum(periodos.map(a => a.QuantidadeCalcinha)),
                QuantidadeSutia: _.sum(periodos.map(a => a.QuantidadeSutia)),
                QuantidadeModelador: _.sum(periodos.map(a => a.QuantidadeModelador))
            }
            this.producaoMultilojaGrupo.TotalPecas = (this.producaoMultilojaGrupo.QuantidadeModelador + this.producaoMultilojaGrupo.QuantidadeSutia + this.producaoMultilojaGrupo.QuantidadeCalcinha);

            let producaoMultilojaDilady = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 1));
            if (producaoMultilojaDilady.length > 0) {
                this.producaoMultilojaDilady = {
                    QuantidadeCalcinha: _.sum(producaoMultilojaDilady.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoMultilojaDilady.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoMultilojaDilady.map(a => a.QuantidadeModelador)),
                    Empresa: producaoMultilojaDilady[0].Empresa
                }
                this.producaoMultilojaDilady.TotalPecas = (this.producaoMultilojaDilady.QuantidadeModelador + this.producaoMultilojaDilady.QuantidadeSutia + this.producaoMultilojaDilady.QuantidadeCalcinha);
            } else {
                this.producaoMultilojaDilady = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 1, Descricao: 'Dilady Lingerie' }
                }
            }

            let producaoMultilojaLoveSecret = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 2));
            if (producaoMultilojaLoveSecret.length > 0) {
                this.producaoMultilojaLoveSecret = {
                    QuantidadeCalcinha: _.sum(producaoMultilojaLoveSecret.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoMultilojaLoveSecret.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoMultilojaLoveSecret.map(a => a.QuantidadeModelador)),
                    Empresa: producaoMultilojaLoveSecret[0].Empresa
                }
                this.producaoMultilojaLoveSecret.TotalPecas = (this.producaoMultilojaLoveSecret.QuantidadeModelador + this.producaoMultilojaLoveSecret.QuantidadeSutia + this.producaoMultilojaLoveSecret.QuantidadeCalcinha);
            } else {
                this.producaoMultilojaLoveSecret = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 2, Descricao: 'Love Secret Lingerie' }
                }
            }

            let producaoMultilojaBanhoDeMar = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 3));
            if (producaoMultilojaBanhoDeMar.length > 0) {
                this.producaoMultilojaBanhoDeMar = {
                    QuantidadeCalcinha: _.sum(producaoMultilojaBanhoDeMar.map(a => a.QuantidadeCalcinha)),
                    QuantidadeSutia: _.sum(producaoMultilojaBanhoDeMar.map(a => a.QuantidadeSutia)),
                    QuantidadeModelador: _.sum(producaoMultilojaBanhoDeMar.map(a => a.QuantidadeModelador)),
                    Empresa: producaoMultilojaBanhoDeMar[0].Empresa
                }
                this.producaoMultilojaBanhoDeMar.TotalPecas = (this.producaoMultilojaBanhoDeMar.QuantidadeModelador + this.producaoMultilojaBanhoDeMar.QuantidadeSutia + this.producaoMultilojaBanhoDeMar.QuantidadeCalcinha);
            } else {
                this.producaoMultilojaBanhoDeMar = {
                    QuantidadeCalcinha: 0,
                    QuantidadeSutia: 0,
                    QuantidadeModelador: 0,
                    TotalPecas: 0,
                    Empresa: { Id: 3, Descricao: 'Banho de Mar Acquashape' }
                }
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterPeriodoProducaoMultiloja(): Promise<PeriodoProducaoMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('PeriodoProducaoMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/periodo-pro-multilojas/periodo-pro-multilojas.ts